import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '../models/location';

@Injectable({
  providedIn: 'root'
})


export class FormularioService {

  private api_location: string = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/';

  constructor(private http: HttpClient) { }

  async getStates() {
    var states = await this.http.get<Location[]>(this.api_location).toPromise();

    states.sort(function(a, b)  {
      return (a.nome < b.nome) ? -1 : (a.nome > b.nome) ? 1 : 0;
    });
    return states;
  }

  async getMunicipio(stateId: number) {
    var municipio = await this.http.get<Location[]>(`${this.api_location}/${stateId}/municipios`).toPromise();

    municipio.sort(function(a, b) {
      return (a.nome < b.nome) ? -1 : (a.nome > b.nome) ? 1 : 0;
    });

    return municipio;
  }
  CepBusca(cep: string)
  {
    return this.http.get(`https://viacep.com.br/ws/${cep}/json/`);
  }
}
